<mat-card *ngIf="errorMessageTypeFromCode === 'default'" role="alert">
  <ten-generic-api-error errorCode="false"></ten-generic-api-error>
</mat-card>
<mat-card
  *ngIf="errorMessageTypeFromCode === 'invalidToken'"
  role="alert"
  [translate]="'ActivateValidationError:InvalidLink'"
>
  Sorry, this request cannot be completed. It looks like your activation link may have expired. If you are still having
  issues then please use the contact us section to call or email us.
</mat-card>
<mat-card
  *ngIf="errorMessageTypeFromCode === 'invalidOldPassword'"
  role="alert"
  [translate]="'ActivateValidationError:OldPassword'"
>
  Sorry, your old password is incorrect. Please try again.
</mat-card>
<mat-card
  *ngIf="errorMessageTypeFromCode === 'sameAsPrevious'"
  role="alert"
  [translate]="'ActivateValidationError:SamePassword'"
>
  Sorry, this request cannot be completed as the password cannot be the same as the previous password. Please enter a
  different password. If you are still having issues then please use the Contact Us section to call or email us.
</mat-card>
<mat-card
  *ngIf="errorMessageTypeFromCode === 'wrongSecurityQuestionAnswer'"
  role="alert"
  [translate]="'ChangePasswordForm:IncorrectSecurityAnswer'"
>
  Answer to this security question is not correct.
</mat-card>
